import { GraduwayEvent } from '../models/data/GraduwayEvent';
import BaseService from './BaseService';

export class GraduwayEventService extends BaseService {
  async getGraduwayEvents() {
    return (await this.getJson<GraduwayEvent[]>('/graduway-events')).data;
  }
}

export default new GraduwayEventService();
